export default "__VITE_ASSET__TJMPWOWh__"